<template>
    <v-container fluid>
      <v-layout align-center justify-center>
        <v-flex xs6>
          <v-card>
            <card-toolbar title="Kredi Kartı İle Satın Al">
            </card-toolbar>
            <v-card-title class="justify-center">Kredi Kartıyla Ödeme</v-card-title>
            <v-card-subtitle class="justify-center text-md-center">
              Ödeme Yapılacak Tutar: <b>{{ payCredit.creditCardToken.amount }}TL</b>
            </v-card-subtitle>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-form lazy-validation ref="form" @submit.prevent="pay">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field required label="Kart Sahibinin Adı"
                              :rules="[$rules.empty('Kart Sahibinin Adı')]" v-model="card.owner.name">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field required label="Kart Numarası" placeholder="5345 6320 0623 0604"
                              :rules="[$rules.empty('Kart Numarası')]" v-mask="'#### #### #### ####'"
                              v-model="card.owner.number">
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-select required label="Son Kullanım Tarihi Ay"
                              :rules="[$rules.empty('Son Kullanım Tarihi Ay')]" :items="info.months" item-text="text"
                              item-value="val" v-model="card.owner.month">
                            </v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-select required label="Son Kullanım Tarihi Yıl"
                              :rules="[$rules.empty('Son Kullanım Tarihi Yıl')]" :items="info.years"
                              v-model="card.owner.year">
                            </v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field required label="CVV" placeholder="310" :rules="[$rules.empty('CVV')]"
                              v-mask="'###'" v-model="card.owner.cvv">
                            </v-text-field>
                          </v-flex>
                          <v-flex class="text-sm-center">
                            <v-btn type="submit">Ödeme Yap</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </template>
  
  <script>
  import { mapActions } from 'vuex';
  import CardToolbar from '../../Components/CardToolbar.vue';
  
  
  const info = {
    years: ['2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032', '2033', '2034', '2035', '2036'],
    months: [
      { val: '01', text: '01 Ocak' },
      { val: '02', text: '02 Şubat' },
      { val: '03', text: '03 Mart' },
      { val: '04', text: '04 Nisan' },
      { val: '05', text: '05 Mayıs' },
      { val: '06', text: '06 Haziran' },
      { val: '07', text: '07 Temmuz' },
      { val: '08', text: '08 Ağustos' },
      { val: '09', text: '09 Eylül' },
      { val: '10', text: '10 Ekim' },
      { val: '11', text: '11 Kasım' },
      { val: '12', text: '12 Aralık' },
  
    ],
  };
  
  export default {
    name: 'Card',
    props: ['payCredit'],
    data: () => ({
      card: {
        owner: {
          name: '',
          number: '',
          month: '',
          year: '',
          cvv: '',
        },
      },
      info,
    }),
    created() {
      // eslint-disable-next-line no-prototype-builtins
      if (!this.payCredit || !this.payCredit.creditCardToken.hasOwnProperty('token')) {
        this.$router.go(-1);
      }
    },
    components: { CardToolbar },
    methods: {
      ...mapActions({ send: 'sendBackend' }),
      microtime(_float) {
        // http://jsphp.co/jsphp/fn/view/microtime
        // +   original by: Paulo Freitas
        // *     example 1: timeStamp = microtime(true);
        // *     results 1: timeStamp > 1000000000 && timeStamp < 2000000000
        const now = new Date().getTime() / 1000;
        const s = parseInt(now, 10);
  
        return (_float) ? now : `${Math.round((now - s) * 1000) / 1000} ${s}`;
      },
      async take(data) {
        let h;
        await this.send({
          route: 'take',
          data,
        }).then((res) => {
          h = res.data.data.hash;
        });
  
        return h;
      },
      async pay() {
        if (this.$refs.form.validate() && this.payCredit) {
          const data = {
            package_id: this.payCredit.selectedPrice.id,
            token: this.payCredit.creditCardToken.token,
            rnd: this.microtime(true),
            pan: this.card.owner.number,
            cv2: this.card.owner.cvv,
            name: this.card.owner.name,
            month: this.card.owner.month,
            year: this.card.owner.year,
          };
  
          const url = `whatsapp/payment`;
          this.send({ route: url, data: data }).then((res) => {
            if (res.data.code == 200 && res.data.status == "success") {
              window.location.href = res.data.data.redirect_url;
            }
          });
        }
      },
    },
  };
  </script>
  